export default "__VITE_ASSET__BYufa4Hw__"